/**
 * 날짜를 화면에 적는 말.
 *
 * 같은 서식이 화면마다 다시 쓰여 있었다 -- 주간 점검 현황과 회차 기록에 '8/24
 * – 8/30' 과 '8월 25일 (화)' 가 글자까지 똑같이 두 벌씩. 한 곳이 바뀌면 다른
 * 곳은 그대로 남아, 같은 날짜를 두 화면이 다르게 적는다.
 *
 * 서버로 보내는 날짜 문자열은 여기가 아니라 `localDate` 가 맡는다. 그쪽은
 * 시간대 때문에 규칙이 다르다.
 */

/** 월요일부터. 시스템이 주를 그렇게 센다. */
export const DAY_LABELS = ['월', '화', '수', '목', '금', '토', '일'];

/** 「8월 25일 (화)」 */
export const fmtDayWithWeekday = (iso) => {
    const d = new Date(iso);
    return `${d.getMonth() + 1}월 ${d.getDate()}일 (${DAY_LABELS[(d.getDay() + 6) % 7]})`;
};

/** 「8/24 – 8/30」 */
export const fmtDayRange = (from, to) => {
    const s = new Date(from);
    const e = new Date(to);
    return `${s.getMonth() + 1}/${s.getDate()} – ${e.getMonth() + 1}/${e.getDate()}`;
};

/** 「2026.8.25」 */
export const fmtDate = (iso) => {
    const d = new Date(iso);
    return `${d.getFullYear()}.${d.getMonth() + 1}.${d.getDate()}`;
};

/** 「8/25」 */
export const fmtDayShort = (iso) => {
    const d = new Date(iso);
    return `${d.getMonth() + 1}/${d.getDate()}`;
};
